import React, { useState, useEffect } from 'react';
import './OrganizationSetup.css';

const OrganizationSetup = ({ onComplete }) => {
  const [formData, setFormData] = useState({
    organizationName: '',
    industry: '',
    maturityStage: ''
  });
  const [maturityStages, setMaturityStages] = useState([]);
  const [loading, setLoading] = useState(true);

  const industries = [
    'Technology',
    'Healthcare',
    'Finance',
    'Manufacturing',
    'Retail',
    'Education',
    'Consulting',
    'Non-Profit',
    'Government',
    'Other'
  ];

  useEffect(() => {
    fetchMaturityStages();
  }, []);

  const fetchMaturityStages = async () => {
    try {
      const response = await fetch('http://localhost:3000/api/maturity-stages');
      const data = await response.json();
      
      if (data.success) {
        setMaturityStages(data.data);
      } else {
        console.error('Error fetching maturity stages:', data.message);
        // Fallback to hardcoded stages if API fails
        setMaturityStages(getFallbackStages());
      }
    } catch (error) {
      console.error('Error fetching maturity stages:', error);
      // Fallback to hardcoded stages
      setMaturityStages(getFallbackStages());
    } finally {
      setLoading(false);
    }
  };

  const getFallbackStages = () => [
    {
      code: 'STARTUP',
      label: 'Start-Up',
      description: 'Fast-growing, still setting structure and processes.'
    },
    {
      code: 'TURNAROUND',
      label: 'Turnaround',
      description: 'Regaining performance and focus after a difficult phase.'
    },
    {
      code: 'GROWTH',
      label: 'Accelerated Growth',
      description: 'Scaling quickly, adding people, markets, or products.'
    },
    {
      code: 'REALIGN',
      label: 'Realignment',
      description: 'Changing direction, structure, or leadership to stay relevant.'
    },
    {
      code: 'SUSTAIN',
      label: 'Sustaining Success',
      description: 'Established and stable; focused on innovation and renewal.'
    }
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.maturityStage) {
      onComplete(formData);
    }
  };

  if (loading) {
    return (
      <div className="organization-setup">
        <div className="setup-container">
          <div className="loading">
            <div className="spinner"></div>
            <p>Loading maturity stages...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="organization-setup">
      <div className="setup-container">
        <div className="setup-header">
          <h1>Culture Assessment</h1>
          <p>Help us understand your organization to provide more accurate insights.</p>
        </div>

        <form onSubmit={handleSubmit} className="setup-form">
          <div className="form-group">
            <label htmlFor="organizationName">Organization Name (Optional)</label>
            <input
              type="text"
              id="organizationName"
              value={formData.organizationName}
              onChange={(e) => handleInputChange('organizationName', e.target.value)}
              placeholder="Enter your organization name"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="industry">Industry</label>
            <select
              id="industry"
              value={formData.industry}
              onChange={(e) => handleInputChange('industry', e.target.value)}
              className="form-select"
            >
              <option value="">Select your industry</option>
              {industries.map(industry => (
                <option key={industry} value={industry}>{industry}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="maturityStage" className="required">
              Our organization could be best described as:
            </label>
            <div className="maturity-options">
              {maturityStages.map(stage => (
                <div
                  key={stage.code}
                  className={`maturity-option ${formData.maturityStage === stage.code ? 'selected' : ''}`}
                  onClick={() => handleInputChange('maturityStage', stage.code)}
                >
                  <div className="option-header">
                    <input
                      type="radio"
                      name="maturityStage"
                      value={stage.code}
                      checked={formData.maturityStage === stage.code}
                      onChange={() => handleInputChange('maturityStage', stage.code)}
                      className="radio-input"
                    />
                    <span className="option-label">{stage.label}</span>
                  </div>
                  <p className="option-description">{stage.description}</p>
                </div>
              ))}
            </div>
          </div>

          <button
            type="submit"
            disabled={!formData.maturityStage}
            className="submit-button"
          >
            Start Assessment
          </button>
        </form>
      </div>
    </div>
  );
};

export default OrganizationSetup;